const $ = require("jquery");
const KEY_ENTER = 13;
const KEY_SPACE = 32;
const CLICK = 1;

$(document).ready(function() {
    $(".list-faq").on("click keydown", ".list-faq__item", function(event) {
        if ([KEY_ENTER, KEY_SPACE, CLICK].includes(event.which) === false) {
            return;
        }

        let $listItemTop = $(this).find(".list-faq__header");

        let $listItem = $(this).closest(".list-faq__item");
        let isOpen = $listItem.hasClass("list-faq__item--open");

        if (isOpen) {
            $listItemTop.attr("aria-expanded", false);
            $listItem.removeClass("list-faq__item--open");
        } else {
            $listItemTop.attr("aria-expanded", true);
            $listItem.addClass("list-faq__item--open");
        }
    });
});
